import UserRequestDTO from "../shared/dtos/userRequestDTO";
import EmptyTripDTO from "../shared/dtos/emptyTripDto";
import axiosInstance from "../app/axios";

export const getEmptyTripsApi = async () => {
  const result = await axiosInstance.get("emptytrip");
  return result.data;
};

export const createEmptyTripApi = async (emptyTrip: UserRequestDTO) => {
  const result = await axiosInstance.post("emptytrip", emptyTrip);

  return result;
};

export const deleteEmptyTripApi = async (id: number) => {
  const result = await axiosInstance.delete(`emptytrip/${id}`);
  return result.data;
};

export const updateProviderByEmptyTripIdApi = async (
  id: number,
  newProviderId: number,
) => {
  const result = await axiosInstance.patch(`$emptytrip/${id}/provider`, {
    newProviderId,
  });
  return result.data;
};

export const updateEmptyTripApi = async (emptyTrip: EmptyTripDTO) => {
  const result = await axiosInstance.put(
    `emptytrip/${emptyTrip.id}`,
    emptyTrip,
  );
  return result.data.data;
};
